module.exports = __webpack_public_path__ + "img/parser.b940c33a.svg";